import "./Footer.css";
import "./FooterResponsive.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faCopyright } from "@fortawesome/free-regular-svg-icons";
import logo from "../../assets/images/logo/Standout-white.png";
import CustomAnchor from "../Anchor/CustomAnchor";
import { faStore } from "@fortawesome/free-solid-svg-icons";

function Footer() {
  return (
    <footer>
      <div className="row m-0">
        <div className="col-lg-4 col-sm-4 col-4 footer-logo-container">
          <div className="d-block">
            <CustomAnchor path="/" classname="">
              <img src={logo} alt="business Logo" onContextMenu={(e) => e.preventDefault()} />
            </CustomAnchor>
          </div>
          <div className="d-block footer-business-name">
            <h3>Standout Fresh Produce</h3>
          </div>
        </div>
        <div className="col-lg-4 col-sm-8 col-8 footer-quick-links">
          <div className="footer--quick-links-wrapper">
            <h3>About Us</h3>
            <ul>
              <li>
                <CustomAnchor path="/about" classname="">
                  <span>Company</span>
                </CustomAnchor>
              </li>
              <li>
                <CustomAnchor path="/about/community" classname="">
                  <span>Community Programs</span>
                </CustomAnchor>
              </li>
              <li>
                <CustomAnchor path="/about/products-services" classname="">
                  <span>Products & Services</span>
                </CustomAnchor>
              </li>
              <li>
                <CustomAnchor path="/about/gallery" classname="">
                  <span>Gallery</span>
                </CustomAnchor>
              </li>
              <li>
                <CustomAnchor path="/about/contact" classname="d-none">
                  <span>Contact</span>
                </CustomAnchor>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-lg-4 col-sm-12 col-12 tagline">
          <h1>Growing Health, Changing Lives, One Harvest at a Time.</h1>
          <CustomAnchor path="/shop" classname="btn btn-warning footer-button">
            <span>SHOP ONLINE</span>
            <FontAwesomeIcon
              icon={faStore}
              className="header-anchor-icon"
            />
          </CustomAnchor>
        </div>
      </div>
      <hr className="m-0 p-0" />
      <div className="footer-declaration row m-0">
        <span className="col-sm-8 col-12 d-flex gap-4 align-items-center">
          <span className="d-flex gap-2 align-items-center">
            <FontAwesomeIcon icon={faCopyright} />
            <span>2025 All Rights Reserved</span>
          </span>
          <div className="web-compliance">
            <CustomAnchor path="/policy" classname="p-0 compliance-link">
              <span>Policy</span>
            </CustomAnchor>
            <CustomAnchor path="/terms-of-service" classname="p-0 compliance-link">
              <span>Terms of Service</span>
            </CustomAnchor>
          </div>
        </span>
        <span className="col-sm-4 col-12 mt-sm-0 mt-2 d-flex gap-2 justify-content-sm-end">
          <CustomAnchor
            path="https://web.facebook.com/profile.php?id=100076482242670"
            classname="footer-fb-icon"
          >
            <FontAwesomeIcon icon={faFacebook} />
          </CustomAnchor>
          <CustomAnchor
            path="https://wa.me/c/27722480000"
            classname="footer-fb-icon"
          >
            <FontAwesomeIcon icon={faWhatsapp} />
          </CustomAnchor>
        </span>
      </div>
    </footer>
  );
}

export default Footer;
